// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"107":"475a028ed58d1d9f","131":"7cb62dc1e744b6fc","720":"ad7cec4c9d59f817"}[chunkId] + ".js";
};